export const FN_EMPTY_VOID = (): void => {}; // eslint-disable-line
